import { initClarity } from './clarity'
import { initHotJarForProduction } from './hotjar'
import reportWebVitals from './reportWebVitals'
import { initSentryForProduction } from './sentry'
import './styles/main.scss'

// initialize sentry
initSentryForProduction()
// initialize clarity
initClarity()
// initialize hotjar
initHotJarForProduction()
if (process.env.REACT_APP_TARGET_BUILD === 'vd') {
  import('vd-web')
} else if (process.env.REACT_APP_TARGET_BUILD === 'dashboard') {
  import('./dashboard/Dashboard')
} else {
  throw new Error(
    'wrong build target!, please check process.env.REACT_APP_TARGET_BUILD'
  )
}
// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// disable warnings in production or via env variables
// motivation: rjsf and material ui blocks the ui to log lots of warnings
const isProd = process.env.REACT_APP_DISABLE_WARNING_LOGS === 'true'
if (isProd) {
  // eslint-disable-next-line
  console.warn = () => {}
}
